import { useEffect, useRef } from "react";

import { useLocation } from "@/lib/router";
import { trackCustomerIOPage } from "@/services/customerio";

export const usePageTracking = () => {
  const { pathname, search } = useLocation();
  const lastUrl = useRef<string | null>(null);

  useEffect(() => {
    const url = `${pathname}${search}`;
    if (lastUrl.current === url) return;
    lastUrl.current = url;

    trackCustomerIOPage(pathname, {
      path: pathname,
      search,
      url: window.location.href,
      referrer: document.referrer,
    });
  }, [pathname, search]);
};
